// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"ff60958f","351":"fc9c1f69","408":"ff60958f","494":"ff60958f","545":"e4103bc8","546":"92b74d39","827":"ff60958f"}[chunkId] + ".chunk.css";
};